import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AppsIcon from '@material-ui/icons/Apps';
import DashboardIcon from '@material-ui/icons/Dashboard';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import StorefrontIcon from '@material-ui/icons/Storefront';
import CloudIcon from '@material-ui/icons/Cloud';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import SearchIcon from '@material-ui/icons/Search';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import ExtensionIcon from '@material-ui/icons/Extension';
import ListIcon from '@material-ui/icons/List';
import TimelineIcon from '@material-ui/icons/Timeline';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import BuildIcon from '@material-ui/icons/Build';
import StorageIcon from '@material-ui/icons/Storage';
import CodeIcon from '@material-ui/icons/Code';
import {
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';

export const SidebarFull = ({ showNotifications }: { showNotifications?: boolean }) => (
  <>
    <SidebarItem icon={SearchIcon} to="/search" text="Search" />
    <SidebarDivider />
    <SidebarGroup label="Tools" icon={<AppsIcon />}>
      <SidebarItem icon={StorefrontIcon} to="/marketplace" text="Marketplace" />
      <SidebarItem icon={SubscriptionsIcon} to="/subscriptions" text="Subscriptions" />
      <SidebarItem icon={ExtensionIcon} to="/operators" text="Operators" />
    </SidebarGroup>
    <SidebarDivider />
    <SidebarGroup label="Catalog" icon={<ListIcon />}>
      <SidebarItem icon={ListIcon} to="/catalog" text="Software Catalog" />
    </SidebarGroup>
    <SidebarItem icon={GroupAddIcon} to="/topology-viewer/builder" text="Services">
      <SidebarSubmenu title="Services">
        <SidebarSubmenuItem title="Service Registry Builder" to="/topology-viewer/builder" icon={BuildIcon} />
        <SidebarSubmenuItem title="GES Builder" to="/ges-builder" icon={StorageIcon} />
        <SidebarSubmenuItem title="GraviteeAPI Operator Builder" to="/gravitee-api-operator-builder" icon={CodeIcon} />
        <SidebarSubmenuItem title="APIM Application Lookup" to="/apim/applications" icon={SettingsInputComponentIcon} />
      </SidebarSubmenu>
    </SidebarItem>
    <SidebarDivider />
    <SidebarGroup label="Community" icon={<AnnouncementIcon />}>
      <SidebarItem icon={AnnouncementIcon} to="/announcements" text="Announcements" />
    </SidebarGroup>
    <SidebarDivider />
    <SidebarItem icon={CloudIcon} to="/links" text="Links">
      <SidebarSubmenu title="Links">
        <SidebarSubmenuItem title="OKD Consoles" to="/okd-consoles" icon={CloudIcon} />
        <SidebarSubmenuItem title="Hydra Tools" to="/our-tools-menu" icon={CloudIcon} />
        <SidebarSubmenuItem title="Datadog" to="/datadog" icon={TimelineIcon} />
      </SidebarSubmenu>
    </SidebarItem>
    <SidebarItem icon={MenuBookIcon} to="/documentation-menu" text="Documentation" />
    <SidebarItem icon={DashboardIcon} to="/ideas" text="Submit Idea" />
    <SidebarItem icon={AccountTreeIcon} to="/topology-viewer" text="Topology" />
    <SidebarItem icon={TrackChangesIcon} to="/tech-radar" text="Tech Landscape" />
    {showNotifications && <NotificationsSidebarItem webNotificationsEnabled />}
  </>
);
